// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__XKLyv","termsLink":"Terms_termsLink__Fo1Xa"};